export default "__VITE_ASSET__HwxkbGP4__"